import { Capacitor } from "@capacitor/core";
import type { DashboardRedirect } from "../interfaces";

export interface NewDashboardRedirectPayload {
  tenantId?: string;
  redirectUrl?: string;
  delayMs?: number;
}

function getValidRedirectTarget(redirectUrl?: string): URL | null {
  if (
    !redirectUrl ||
    Capacitor.isNativePlatform() ||
    typeof window === "undefined"
  ) {
    return null;
  }

  try {
    const target = new URL(redirectUrl, window.location.origin);
    if (target.origin === window.location.origin) {
      return null;
    }
    return target;
  } catch (error) {
    console.warn("Invalid new dashboard redirect URL:", error);
    return null;
  }
}

export function redirectToNewDashboard(
  dashboard?: DashboardRedirect | null,
): boolean {
  if (!dashboard || dashboard.experience !== "new") {
    return false;
  }

  const target = getValidRedirectTarget(dashboard.redirectUrl);
  if (!target) {
    return false;
  }

  window.location.assign(target.toString());
  return true;
}

export function scheduleNewDashboardRedirect(
  payload?: NewDashboardRedirectPayload | null,
): ReturnType<typeof setTimeout> | null {
  const target = getValidRedirectTarget(payload?.redirectUrl);
  if (!target) {
    return null;
  }

  const delayMs =
    typeof payload?.delayMs === "number" && Number.isFinite(payload.delayMs)
      ? payload.delayMs
      : 5000;

  return setTimeout(() => {
    window.location.assign(target.toString());
  }, delayMs);
}
